import { useState, useEffect } from "react";
import { twMerge } from "tailwind-merge";

const fmt = (n) => {
  if (n === "" || n === null || n === undefined) return "";
  const num = Number(n);
  if (isNaN(num)) return "";
  return num.toLocaleString("id-ID");
};

export function CurrencyInput({ value, onChange, className = "", placeholder, "data-testid": testId }) {
  const [display, setDisplay] = useState(fmt(value));

  useEffect(() => {
    setDisplay(fmt(value));
  }, [value]);

  const handle = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    const num = raw === "" ? 0 : parseInt(raw, 10);
    setDisplay(raw === "" ? "" : num.toLocaleString("id-ID"));
    onChange(num);
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none font-mono">Rp</span>
      <input
        inputMode="numeric"
        value={display}
        onChange={handle}
        placeholder={placeholder}
        data-testid={testId}
        className={twMerge(className, "pl-10 font-mono")}
      />
    </div>
  );
}
